const ratePlansOf = (roomTypes) => roomTypes.flatMap(roomType => roomType.ratePlans);
export const toAvailabilityContext = (property, roomTypes) => {
    const ratePlans = ratePlansOf(roomTypes);
    const ratePlanIds = [...new Set(ratePlans.map(plan => plan.ratePlanId))];
    const ratePlanNames = Object.fromEntries(ratePlans.map(plan => [plan.ratePlanId, plan.ratePlanName]));
    return { property, ratePlanIds, ratePlanNames };
};
